module.exports = __webpack_public_path__ + "img/3.32cdd945.png";